// extracted by mini-css-extract-plugin
export var about = "About-module--about--db321";
export var container = "About-module--container--c2565";
export var copy = "About-module--copy--744a6";
export var cta = "About-module--cta--ac62d";
export var fadeIn = "About-module--fadeIn--5dfcd";
export var header = "About-module--header--fdfde";
export var heading = "About-module--heading--0cfa6";
export var nav = "About-module--nav--46488";
export var navButton = "About-module--navButton--2562d";
export var navContainer = "About-module--navContainer--630ad";
export var navList = "About-module--navList--2d2e2";
export var panel = "About-module--panel--48ddb";
export var panels = "About-module--panels--956a4";
export var tag = "About-module--tag--c2a1c";
export var tags = "About-module--tags--1acc6";
export var wrapper = "About-module--wrapper--93f48";